import { fetchReducer } from 'iqvia-shared';
import reduceReducers from 'reduce-reducers';

import apiNameEnums from '../../../Enums/apiNames';

const defaultState = {
  value: {
    organization: { id: '' },
  },
  isLoading: false,
};

const userData = (state = defaultState, { type }) => {
  switch (type) {
    default:
      return state;
  }
};

export default reduceReducers(userData, fetchReducer(apiNameEnums.GET_USER_DATA));



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/reducers/userData.js